Object.defineProperty(exports, '__esModule', {
    value: true
});
var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;
var ERROR_REVALIDATE_EVENT = 3;
exports.ERROR_REVALIDATE_EVENT = ERROR_REVALIDATE_EVENT;
exports.FOCUS_EVENT = FOCUS_EVENT;
exports.MUTATE_EVENT = MUTATE_EVENT;
exports.RECONNECT_EVENT = RECONNECT_EVENT;
